export { StarRating } from "./StarRating";